export const {
  VITE_API_URL: API_URL,
  VITE_ENV: ENV,
  VITE_SENTRY_DSN: SENTRY_DSN,
  VITE_GOOGLE_API_KEY: GOOGLE_API_KEY,
}: Record<string, string> = import.meta.env;
